// extracted by mini-css-extract-plugin
module.exports = {"emoji":"Emoji_emoji__3sT1m"};